export default {
    index: '/',

    areas: {
        show: '/{area}',
        changes: {
            index: '/{area}/changes',
            show: '/{area}/changes/{item}',
        },
        faq: {
            index: '/{area}/faq',
        },
        sections: {
            pages: {
                show: '/{area}/{section}/{page}',
                create: '/{area}/{section}/create',
                edit: '/{area}/{section}/{page}/edit',

                pages: {
                    show: '/{area}/{section}/{page}/{sub_page}',
                    create: '/{area}/{section}/{page}/create',
                    edit: '/{area}/{section}/{page}/{sub_page}/edit',
                }
            }
        }
    }
}
